import { memo } from 'react';
import PropTypes from 'prop-types';
// mui
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import { Typography, useTheme } from '@mui/material';
// components
import { RouterLink } from 'src/routes/components';
import { RenderLogo } from 'src/components/animate/animate-logo';
// config
import { APP_CONFIG } from 'src/config-global';

// ----------------------------------------------------------------------

function LogoSalesRush({ redirect }) {
  const theme = useTheme();

  return (
    <Link
      component={RouterLink}
      href={redirect ? redirect : APP_CONFIG.app_main_domain}
      color='inherit'
      aria-label='go to homepage'
      sx={{ lineHeight: 0 }}
    >
      {theme.direction === 'rtl'
        ?
        <Box display='flex'>
          <Typography variant='h6' sx={{ mt: 0.5 }}>AI.SALESRUSH</Typography>
          <RenderLogo width={30} height={30} />
        </Box>
        :
        <Box display='flex'>
          <RenderLogo width={30} height={30} />
          <Typography variant='h6' sx={{ mt: 0.5 }}>SALESRUSH.AI</Typography>
        </Box>
      }
    </Link>
  );
}

LogoSalesRush.propTypes = {
  redirect: PropTypes.string,
};

export default memo(LogoSalesRush);
